<template>
  <div
    @click.once="$emit('onClick', question)"
    v-translate:dynamic_string="{
      key: `${translationKeyInitial}_formattedBody`,
      val: lang,
      html: question.formattedBody
    }"
    v-html="question.formattedBody"
  />
</template>

<script>
import langTranslate from "./lang-translate";

export default {
  name: "validated-entry",
  mixins: [langTranslate],
  data() {
    return {
      hasFieldError: false,
      fieldErrorText: "",
      scoresMap: {}
    };
  },
  props: ["lang", "question", "isFieldDisabled", "isLegacyStudy"],
  computed: {
    componentData() {
      return this.question.constraints;
    }
  },
  methods: {
    onAnswerChange(e) {
      this.$nextTick(() => {
        this.onChangeOptions(e);
        this.$emit("onAnswerChange", this.componentData);
      });
    },
    onChangeOptions(e) {
      this.componentData.computedScore = this.scoresMap[e];
      this.componentData.actualScore = this.scoresMap[e];
    }
  }
};
</script>
